import React from 'react';

import { Box, Divider, Paper, Stack, Typography } from '@mui/material';

import { useDashboardCVAdminData } from 'src/hooks/dashboard';
import { SxProp } from 'src/types/mui';

import { getCompaniesNames } from './utils/getCompaniesNames';

export const DashboardFilterPreviewPrint: React.FC = () => {
  const { employers, peos } = useDashboardCVAdminData();

  const companyNames = React.useMemo(
    () => getCompaniesNames({ filters: { employer: employers ?? [], PEO: peos ?? [] } }),
    [employers, peos],
  );

  const getEmployerFilterText = () => {
    const isEmployerEmpty = companyNames.Employer.length === 0;

    const isEmployerSelectAll = !employers?.[0];

    if (isEmployerEmpty && isEmployerSelectAll) {
      return 'All';
    }
    if (isEmployerEmpty) {
      return 'Not selected';
    }
    return companyNames.Employer.join(', ');
  };

  const getPeoFilterText = () => {
    const isPeoEmpty = companyNames.PEO.length === 0;

    const isPeoSelectAll = !peos?.[0];

    if (isPeoEmpty && isPeoSelectAll) {
      return 'All';
    }
    if (isPeoEmpty) {
      return 'Not selected';
    }
    return companyNames.PEO.join(', ');
  };

  // const getPeoPayrollProviderFilterText = () => {
  //   const isPeoPayrollProviderEmpty = companyNames['PEO Payroll Provider'].length === 0;
  //
  //   const isPeoPayrollProviderSelectAll = rawCustomFilter
  //     .find(filter => filter.type === DashboardFilterCVAdminCustomFilterType.PEOPayrollProvider)
  //     ?.value.find(value => (value as DefaultOption).label === 'Select all');
  //
  //   if (isPeoPayrollProviderEmpty && isPeoPayrollProviderSelectAll) {
  //     return 'All';
  //   }
  //   if (isPeoPayrollProviderEmpty) {
  //     return 'Not selected';
  //   }
  //   return companyNames['PEO Payroll Provider'].join(', ');
  // };

  return (
    <Paper sx={paperStyles} variant="outlined">
      <Stack spacing={2}>
        <Typography variant="subtitle1">Selected options</Typography>
        <Divider />
        <Box display="flex" gap={1} flexDirection="row">
          <Stack spacing={2}>
            <Typography variant="body1" color="text.secondary">
              PEO
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Employer
            </Typography>
          </Stack>
          <Stack spacing={2}>
            <Typography variant="body1" color="text.secondary">
              {getPeoFilterText()}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {getEmployerFilterText()}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

const paperStyles: SxProp = { p: 2, borderRadius: 2, flexBasis: 0, flexGrow: 1, minWidth: 250 };
